import React from 'react'
import { injectIntl } from 'react-intl'
import Grid from '@material-ui/core/Grid'
import { compose } from 'recompose'
import defaultImage from '../../../../assets/dashboard/results.jpg'
import { makeStyles } from '@material-ui/styles'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles((theme) => ({
	gridRoot: {
        flex: '1',
		margin: '50px auto',
		maxWidth: 'calc(100vw - 48px)',
		[theme.breakpoints.down('md')]: {
			maxWidth: '100vw',
		},
		[theme.breakpoints.down('sm')]: {
			margin: '0',
			flexDirection: 'column-reverse',
			maxWidth: '100vw',
			width: '100vw'
        },
	},
    textRoot: {
		margin: '0 0 30px 0'
    },
    descriptionRoot: {
        margin: '0 0 30px 0',
        lineHeight: '1.8'
    },
    imageRoot: {
        width: '100%',
        height: 'auto',
        boxShadow: '0 5px 10px rgba(0,0,0,0.09), 0 3px 3px rgba(0,0,0,0.13)'
    }
}))

const PatientPathology = ({ intl, pathology }) => {
	const classes = useStyles()

	return (
		<Grid data-testid="patient-pathology" container spacing={6} className={classes.gridRoot}>
			<Grid item sm={12} md={6} className={classes.gridItem}>
				<Typography data-testid="patient-pathology-name" variant='h4' className={classes.textRoot}>
					{pathology.name}
				</Typography>
				<Typography data-testid="patient-pathology-decription" variant='body1' className={classes.descriptionRoot}>
					{pathology.description}
				</Typography>
			</Grid>
			<Grid item sm={12} md={6} className={classes.gridItem}>
				<img alt="Pathology Image" data-testid="patient-pathology-img" src={pathology.imageUrl ? pathology.imageUrl : defaultImage} className={classes.imageRoot} />
			</Grid>
		</Grid>
	)
}

const enhance = compose(injectIntl)

export default enhance(PatientPathology)
